
window.createClass = createClass;

